import { getFeatureFlags, IFeatureFlag } from '../queries/feature_flags/useFeatureFlags';
import authService from '../services/auth';

const setupFeatureFlags = (featureFlagsData: IFeatureFlag[]) => {
  if (featureFlagsData && Object.keys(window.__amp_feature_flags).length === 0) {
    featureFlagsData.forEach(
      feature_flag => (window.__amp_feature_flags[feature_flag.feature_name] = feature_flag.enabled)
    );
  }
};

export const signInToAmp = async (setIsAuthenticatedToBackend: (isAuthenticatedToBackend: boolean) => void) => {
  try {
    const [, featureFlagsData] = await Promise.all([authService.fetchCurrentUser(), getFeatureFlags()]);

    setupFeatureFlags(featureFlagsData.feature_flags);
    setIsAuthenticatedToBackend(true);
  } catch (_) {
    setIsAuthenticatedToBackend(false);
  }
};
